import auth from "@/middleware/auth";

export default [
    {
        path: "resumo-acordo",
        name: "resumoAcordoTricard",
        meta: { middleware: [auth] },
        component: () => import("./ResumoAcordoTricard")
    }
];
